module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('v-progress-circular', {
    staticClass: "purple--text",
    attrs: {
      "indeterminate": "",
      "size": 70,
      "width": 7
    }
  }), _vm._v(" "), _c('h1', [_vm._v("Login ...")])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c4379eca","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Login.vue
// module id = 397
// module chunks = 0